<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<!-- start scroll to top -->
<a class="scroll-top-arrow" href="javascript:void(0);"><i class="feather icon-feather-arrow-up"></i></a>
<!-- end scroll to top -->